import { render, staticRenderFns } from "./PointWriteServiceLayout.vue?vue&type=template&id=a7f06f04&scoped=true&"
import script from "./PointWriteServiceLayout.vue?vue&type=script&lang=js&"
export * from "./PointWriteServiceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f06f04",
  null
  
)

export default component.exports